module.exports = __webpack_public_path__ + "static/media/main.a6af89f2.jpg";